import { RefObject } from "react";
import { RefCallBack } from "react-hook-form";
import useTranslations from "../../../../../core/i18n/useTranslations";
import NumberInput from "../../../../../ui-lib/components/Inputs/NumberInput";

export const TimeoutControl = ({
  label,
  min = 1,
  max = 3600,
  value,
  onChange,
  hasError,
  withValidationMessage = true,
  disabled,
  required,
  inputRef,
}: {
  label?: string;
  min?: number;
  max?: number;
  value?: number | null;
  onChange: (value?: number | null) => void;
  hasError?: boolean;
  withValidationMessage?: boolean;
  disabled?: boolean;
  required?: boolean;
  inputRef?: RefObject<HTMLInputElement> | RefCallBack;
}) => {
  const t = useTranslations();

  const placeholder = `${min}...${max}`;

  return (
    <NumberInput
      withValidationMessage={withValidationMessage}
      inputRef={inputRef}
      required={required}
      label={label}
      placeholder={placeholder}
      pinnedText="sec"
      pinnedTextPosition="right"
      width="100%"
      value={value === null ? "" : String(value)}
      disabled={disabled}
      onChange={(e) => {
        const nextValue = e.currentTarget.value;
        onChange(nextValue === "" ? null : Number(nextValue));
      }}
      validationError={
        hasError ? `${t("Errors:input_format")}: ${placeholder}` : undefined
      }
    />
  );
};
